import {useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {snakeToCamel} from 'helpers';
import {updateCandidateProfile} from '../actionCreators';

const useCandidateSaveFields = (candidateId, fields, formApi = false, onDuplicatesFound = null) => {
  const dispatch = useDispatch();

  return useMemo(
    () =>
      fields.reduce((nextEvents, field) => {
        // Should probably find a better way that this but this is fine for the moment
        // eslint-disable-next-line fp/no-mutation, no-param-reassign
        nextEvents[snakeToCamel(`on_save_${field}`)] = value => {
          dispatch(
            updateCandidateProfile(
              candidateId,
              {
                [field]: formApi ? formApi.getValue(field) : value,
              },
              onDuplicatesFound
            )
          );
        };

        return nextEvents;
      }, {}),
    [candidateId, dispatch, fields, formApi, onDuplicatesFound]
  );
};

export default useCandidateSaveFields;
